angular.module 'zc.projects'

.controller 'TrackingTagCtrl',($scope, Project, MongoHistory, SettingStatus, currentProject, TagNonExistingUrls) ->
  $scope.histories = []
  $scope.tag_non_existing_url_items = []
  $scope.foundPC = false
  $scope.foundSP = false

  $scope.isDisplayAajsWarningMsg = currentProject.enable_aajs &&
    _.some([
      currentProject.site_id,
      currentProject.tracking_id,
      currentProject.scope_id
    ],
      (item) => !(item && item.length > 0)
    )

  if currentProject.enable_aajs
    scope_id = currentProject.scope_id || '[scope-id]'
    site_id = currentProject.site_id || '[site-id]'
    track_id = currentProject.tracking_id || '[track-id]'
    $scope.tracking_tag_code = """
<script>
  window.appier_q = window.appier_q || [];
  window.appier_q.push(
    {"t": "register", "content": { "id": "#{scope_id}", "site": "#{site_id}" }},
    {"t": "pv_track", "action_id": "#{site_id}_PageView", "track_id": "#{track_id}", "isCountReload": true, "counter": 0},
    {"t": "pv_track", "action_id": "#{site_id}_ViewTwoPages", "track_id": "#{track_id}", "isCountReload": false, "counter": 1}
  );
</script>
<script src="//jscdn.appier.net/aa.js?id=#{site_id}" async></script>
"""
  else
    $scope.tracking_tag_code = """
<script type="text/javascript" src="//#{currentProject.publish_domain}.zenclerk.com/publish/#{currentProject.apikey}.js"></script>
"""

  $scope.refresh = ->
    TagNonExistingUrls.findOne
      apikey: currentProject.apikey
    .then (res) ->
      return unless res?.url_items
      $scope.tag_non_existing_url_items = _.map res.url_items, ([url, count]) ->
        {
          url,
          count: parseInt count
        }

    MongoHistory.find
      apikey: currentProject.apikey
    ,
      sort:
        opened_at: -1
      limit: 10
    .then (histories) ->
      $scope.foundPC = false
      $scope.foundSP = false
      $scope.histories = histories
      for history in histories
        $scope.foundPC = true if history.device is 'pc'
        $scope.foundSP = true if history.device is 'sp'
  $scope.refresh()

  $scope.updateStatus = (opts) ->
    return if !$scope.foundPC && !$scope.foundSP
    currentProject.tracking_tag_confirmed = true
    Project.update
      projectId: currentProject.id
    ,
      project: currentProject
    .then (result) ->
      currentProject = _.merge(currentProject, result);
      SettingStatus.updateProjectStatus currentProject



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/installation/tracking_tag.controller.coffee